import { Box, Button, Checkbox, Flex, Grid, Label, Text } from "atoms";
import React from "react";
import MemoClose from "assets/icons/Close";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { DateInput } from "atoms/DateInput";

const validationSchema = Yup.object().shape({
  firstname: Yup.string().max(60, "Maximum 60 characters").required("Required"),
  lastname: Yup.string().max(60, "Maximum 60 characters"),
});

export const ActivityFilter = ({ onClose }) => {
  const onSubmit = () => {};

  return (
    <Box
      width="48rem"
      p="3.2rem"
      bg="white"
      borderRadius="1rem"
      boxShadow="4px 4px 40px rgba(0, 0, 0, 0.06)"
    >
      <Flex
        mb="2.4rem"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="neutral.100"
        pb="2.4rem"
      >
        <Text fontSize="2rem" color="primary.900" fontFamily="NeometricBold">
          Filter
        </Text>
        <MemoClose
          height="1.5rem"
          width="1.5rem"
          onClick={onClose}
          style={{ cursor: "pointer" }}
        />
      </Flex>
      <Formik
        initialValues={{
          startDate: "",
          endDate: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {() => {
          return (
            <Form>
              <Grid gridRowGap="2.4rem">
                <Grid pr="5rem">
                  <Label text="Activity" mb="1.8rem" />
                  <Flex gridGap="2rem" flexWrap="wrap">
                    <Checkbox name="create" height="1.8rem" label="Create" />
                    <Checkbox name="delete" height="1.8rem" label="Delete" />
                    <Checkbox name="publish" height="1.8rem" label="Publish" />
                    <Checkbox name="view" height="1.8rem" label="View" />
                    <Checkbox
                      name="unpublish"
                      height="1.8rem"
                      label="Unpublish"
                    />
                  </Flex>
                </Grid>
                <Label text="Start Date" />
                <DateInput name="startDate" />
                <Label text="End Date" />
                <DateInput name="endDate" />
                <Button
                  type="submit"
                  variant="primary"
                  height={{ xs: "4.3rem", lg: "4.8rem" }}
                  mt="1rem"
                >
                  Filter
                </Button>
              </Grid>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};
